import React from 'react';
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

export default function TableDropDown({
  value,
  setValue,
  data,
  filterName,
  sx,
}) {
  return (
    <FormControl
      variant="outlined"
      sx={{ minWidth: 150, marginRight: 1, ...sx }}
      size="small"
    >
      <InputLabel id={`${filterName}-single-label`}>{filterName}</InputLabel>
      <Select
        labelId={`${filterName}-single-label`}
        id={`${filterName}-single-select`}
        label={filterName}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        IconComponent={KeyboardArrowDownIcon}
      >
        <MenuItem value="">
          <Typography>All</Typography>
        </MenuItem>

        {data.map((item) => (
          <MenuItem key={item.value} value={item.value}>
            {item.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}